import { render, staticRenderFns } from "./OrderClientNameField.vue?vue&type=template&id=02def397&scoped=true&"
import script from "./OrderClientNameField.vue?vue&type=script&lang=js&"
export * from "./OrderClientNameField.vue?vue&type=script&lang=js&"
import style0 from "./OrderClientNameField.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02def397",
  null
  
)

export default component.exports